import { render, staticRenderFns } from "./invInfoDc.vue?vue&type=template&id=0b1cd819"
import script from "./invInfoDc.vue?vue&type=script&lang=js"
export * from "./invInfoDc.vue?vue&type=script&lang=js"
import style0 from "./invInfoDc.vue?vue&type=style&index=0&id=0b1cd819&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports